<script>
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  MailIcon,
} from "vue-feather-icons";
import appConfig from "@/app.config";
import axios from 'axios';

// 초기세팅
function initialState() {
  return {
    baseInfo: {},
    newsLetter: {
      name: '',
      email: '',
    },
  };
}

export default {
  data() {
    return {
      appConfig: appConfig,
      ...initialState(),
      isRolling: false,
    };
  },
  props: {
    isWhiteNavbar: {
      type: Boolean,
    },
    navLight: {
      type: Boolean,
    },
    loginInfo: {
      type: Object,
      required: true, // 필수 props로 지정할 수 있음
    },
  },
  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    MailIcon,
  },
  mounted() {
  },
  created() {
    this.getWebSiteInfoBase()
  },
  methods: {
    goAdmin() {
      this.$router.push('/os');
    },
    logOut() {
      localStorage.removeItem('user');
      this.$store.commit("setAuthIdx", "")
      this.$store.commit("setAuthAccessToken", "")
      this.$store.commit("setAuthNick", "")
      this.$store.commit("setAuthLevel", 0)
      this.$store.commit("setAuthIsLogin", false)
      this.$store.commit("setAuthEmail", "")
      // 메인으로 이동
      this.$router.go(0);
    },
    // 홈페이지 기본정보
    getWebSiteInfoBase() {
      this.baseInfo = this.$store.getters.getWebSiteInfoBase
    },
    newTab(val) {
      var win = window.open(val, '_blank');
      win.focus();
    },
    // 소식받기 클릭
    submitNewsLetter() {
      // 항목 다 채웠는지 체크하고 newsLetter.email 이메일 형식 체크 (@들어가고 . 들어가야됨)
      if (this.newsLetter.name == '' || this.newsLetter.email == '' || !this.newsLetter.email.includes('@') || !this.newsLetter.email.includes('.')) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '항목을 모두 채워주세요. 이메일 형식도 맞춰주세요.' });
        return;
      } else {
        // 소식받기 클릭
        axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/subscribeNewsletter',
          data: {
            "newsLetterName": this.newsLetter.name,
            "newsLetterEmail": this.newsLetter.email,
          },
        })
        .then((response) => {
          if (response.data.type == 'success') {
            this.$notify({ type: 'success', duration:2000, 'title': '성공', text: response.data.message})
          } else if (response.data.message) {
            this.$notify({ type: 'error', duration:3000, 'title': '실패', text: response.data.message})
          } else {
            this.$notify({ type: 'error', duration:3000, 'title': '실패', text: '관리자에게 문의해주세요'})
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response) {
            this.$notify({ type: 'error', duration:3000, 'title': error.response.status+' 에러', text: error.response.data.detail})
          }
        })
      }
    },
    jyClick() {
      // 애니메이션 시작
      this.isRolling = true;
      // 애니메이션 후 원래 위치로 복귀
      setTimeout(() => {
        this.isRolling = false;
      }, 4000);
      // 알림 표시
      this.$notify({ type: 'info', duration: 3000, title: '정연', text: '데헷!! 또 버그 발견!?'})
    }
  },
};
</script>

<template>
  <div>
    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-12 mb-0 mb-md-4 pb-0 pb-md-2">
            <router-link class="logo-footer" to="/" v-if="navLight !== true">
              <span class="btn btn-light text-white font-size-14">
                <img :src="`${appConfig.url}/images/_decen/logo/logo_old.png`" width="24" alt="" />
                <span v-if="this.baseInfo.shortName" class="ml-1">{{ this.baseInfo.shortName }}</span>
              </span>
            </router-link>
            <div v-if="this.baseInfo" class="font-size-14">
              <div v-if="this.baseInfo.address" class="mt-2">{{ this.baseInfo.address }}</div>
              <div v-if="this.baseInfo.office1Name" class="mt-2">{{ this.baseInfo.office1Name }} {{ this.baseInfo.office1Number }}</div>
              <div v-if="this.baseInfo.office2Name" class="mt-2">{{ this.baseInfo.office2Name }} {{ this.baseInfo.office2Number }}</div>
              <div v-if="this.baseInfo.fax1Number" class="mt-2">FAX: {{ this.baseInfo.fax1Number }}</div>
            </div>
            <ul class="list-unstyled social-icon social mb-0 mt-4">
              <li v-if="this.baseInfo.sns1" class="list-inline-item">
                <a @click="newTab(baseInfo.sns1)" href="javascript:void(0)" class="rounded">
                  <i class="uil-facebook"></i>
                </a>
              </li>
              <li v-if="this.baseInfo.sns2" class="list-inline-item ml-1">
                <a @click="newTab(baseInfo.sns2)" href="javascript:void(0)" class="rounded">
                  <i class="uil-instagram"></i>
                </a>
              </li>
              <li v-if="this.baseInfo.sns3" class="list-inline-item ml-1">
                <a @click="newTab(baseInfo.sns3)" href="javascript:void(0)" class="rounded">
                  <i class="uil-comment-dots"></i>
                </a>
              </li>
              <li v-if="this.baseInfo.sns4" class="list-inline-item ml-1">
                <a @click="newTab(baseInfo.sns4)" href="javascript:void(0)" class="rounded">
                  <i class="uil-twitter-alt"></i>
                </a>
              </li>
            </ul>
            <!-- 후원계좌 -->
            <div v-if="this.baseInfo.bankName" class="text-sm-left mb-2">
              <p class="mb-0 font-size-13">
                <span class="text-bold"><i class="mdi mdi-bank"></i> 후원계좌</span> </br>
                <span class="text-bold">예금주</span>: {{ this.baseInfo.accountHolder }} </br>
                <span class="text-bold">계좌번호</span>: {{ this.baseInfo.bankName }} {{ this.baseInfo.accountNumber }}
              </p>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <h5 class="text-light footer-head">센터</h5>
            <ul class="list-unstyled footer-list mt-4">
              <li>
                <router-link to="/menu-intro" class="text-foot">
                  <i class="mdi mdi-chevron-right mr-1"></i> 센터 소개
                </router-link>
              </li>
              <li>
                <router-link to="/menu-doing" class="text-foot">
                  <i class="mdi mdi-chevron-right mr-1"></i> 부설 기관
                </router-link>
              </li>
              <li>
                <router-link to="/menu-timeline" class="text-foot">
                  <i class="mdi mdi-chevron-right mr-1"></i> 연혁
                </router-link>
              </li>
              <li>
                <router-link to="/menu-intro#contact" class="text-foot">
                  <i class="mdi mdi-chevron-right mr-1"></i> 오시는 길
                </router-link>
              </li>
            </ul>
          </div>

          <div class="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <h5 class="text-light footer-head">안내</h5>
            <ul class="list-unstyled footer-list mt-4">
              <li>
                <router-link to="/sign-up" class="text-foot">
                  <i class="mdi mdi-chevron-right mr-1"></i> 후원 신청
                </router-link>
              </li>
              <li>
                <router-link to="/jy/5/w" class="text-foot">
                  <i class="mdi mdi-chevron-right mr-1"></i> 비밀보장 상담문의
                </router-link>
              </li>
              <li>
                <router-link to="/privacy-policy" class="text-foot">
                  <i class="mdi mdi-chevron-right mr-1"></i> 개인정보 처리방침
                </router-link>
              </li>
            </ul>
          </div>

          <div class="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <h5 class="text-light footer-head">
              이메일소식지 신청
            </h5>
            <div class="row">
              <div class="col-lg-12">
                <div class="foot-subscribe form-group">
                  <label for="newsLetterName">
                    성함을 적어주세요
                    <span class="text-danger">*</span>
                  </label>
                  <div class="position-relative">
                    <input
                      type="text"
                      v-model="newsLetter.name"
                      id="newsLetterName"
                      class="form-control pl-5 rounded bg-soft-light"
                      placeholder=""
                      required
                    />
                  </div>
                  <label for="newsLetterEmail"  >
                    이멜주소를 적어주세요
                    <span class="text-danger">*</span>
                  </label>
                  <div class="position-relative">
                    <mail-icon class="fea icon-sm icons"></mail-icon>
                    <input
                      type="email"
                      v-model="newsLetter.email"
                      id="newsLetterEmail"
                      class="form-control pl-5 rounded bg-soft-light"
                      placeholder="@ "
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-12">
                <input
                  @click="submitNewsLetter()"
                  type="submit"
                  id="submitNewsLetter"
                  name="send"
                  class="btn btn-primary btn-block"
                  value="소식받기"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-2 p-2">
        <div class="container text-center">
          <div class="row align-items-center">
            <div class="col-sm-8">
              <div class="text-sm-left">
                <p class="mb-0 font-size-11">
                  Copyright © 2001 - {{ new Date().getFullYear() }} 
                  <span v-if="this.baseInfo.shortName" class="">{{ this.baseInfo.longName }}  All Rights Reserved.</span>
                  <router-link to="/member-login">
                    <i class="mdi mdi-heart text-danger"></i>
                  </router-link>
                  <div class="font-size-10 text-muted">website published by <span @click="jyClick()" :class="{ 'rolling-text': isRolling }" class="cursor-pointers">정연.</span></div>
                </p>
              </div>
            </div>
            
            <div v-if="loginInfo" class="col-sm-4">
              <!-- 관리자만 보이게 -->
              <div v-if="loginInfo.level > 97 && loginInfo.isLogin == true" class="text-sm-right">
                <p class="mb-0 font-size-12">
                  <span>
                    <span @click="goAdmin()" class="text-bold cursor-pointers rounded bg-info text-white px-2 py-2">
                      관리페이지 <i class="mdi mdi-badge-account-horizontal h5"></i>
                    </span>
                    <span @click="logOut()" class="text-bold cursor-pointers ml-3 rounded bg-danger text-white px-2 py-2">
                      로그아웃 <i class="mdi mdi-logout h5"></i>
                    </span>
                  </span>
                </p>
              </div>
              <div v-else-if="loginInfo.level > 0" class="text-sm-right">
                <p class="mb-0 font-size-12">
                  <span>
                    <span @click="logOut()" class="text-danger cursor-pointers ml-3">
                      로그아웃 <i class="mdi mdi-logout h5"></i>
                    </span>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>

  </div>
</template>

<style scoped>
.rolling-text {
  display: inline-block;
  font-size: 16px !important;
  animation: growAndRoll 4s ease-in-out;
}

@keyframes growAndRoll {
  0% {
    transform: scale(1) translateX(0) rotate(0deg);
  }
  10% {
    transform: scale(1.6) translateX(0) rotate(0deg);
  }
  25% {
    transform: scale(1.6) translateX(50px) rotate(180deg);
  }
  50% {
    transform: scale(1.6) translateX(100px) rotate(360deg);
  }
  75% {
    transform: scale(1.6) translateX(150px) rotate(540deg);
  }
  100% {
    transform: scale(1.6) translateX(200px) rotate(720deg);
  }
}

.cursor-pointers {
  cursor: pointer;
  transition: all 0.3s ease;
}

.cursor-pointers:hover {
  opacity: 0.8;
}
</style>
